const files = require.context('.', true, /\.js$/)

const modules = {}

files.keys().forEach((key) => {
  if (key === './index.js') return
  // modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
  const childModule = files(key).default
  for (const key in childModule) {
    modules[key] = childModule[key]
  }
})

let installed = false

const install = (app, option = {}) => {
  if (installed) {
    return
  }
  installed = true
  app.config.globalProperties.$api = modules
}

// if window.Vue
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}
